export class CalmMetadata {
    constructor(originalJson, data) {
        this.originalJson = originalJson;
        this.data = data;
    }
    toSchema() {
        return this.originalJson;
    }
    static fromSchema(schema) {
        const flattened = Array.isArray(schema)
            ? Object.assign({}, ...schema)
            : schema;
        return new CalmMetadata(schema, flattened);
    }
    toCanonicalSchema() {
        return this.data;
    }
}
//# sourceMappingURL=metadata.js.map